export default __webpack_public_path__ + "./image/ffb2973fac03c991a04234595607cc5c.png";